var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccordionCarret = function SvgAccordionCarret(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02113 0.226015L3.32746 0.937716C3.02749 1.24227 3.03374 1.73918 3.33996 2.03733L8.3125 7L3.33996 11.9627C3.03687 12.2608 3.03062 12.7577 3.32746 13.0623L4.02113 13.774C4.31172 14.0753 4.78667 14.0753 5.08039 13.774L11.1547 7.54179C11.4484 7.24365 11.4484 6.75635 11.1547 6.455L5.08039 0.226015C4.7898 -0.0753359 4.31485 -0.0753358 4.02113 0.226015Z",
    fill: "#999999"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccordionCarret);
export default ForwardRef;